/**
 * HelpContent.jsx
 * Created by Mike Bray 4/1/16
 */

import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

const propTypes = {
    changelog: PropTypes.string,
    technical: PropTypes.string
};

const HelpContent = (props) => {
    return (
        <div className="usa-da-help-content">
            <h2 className="usa-da-help-content__header">What&#8217;s New in This Release</h2>
            <Markdown>{props.changelog}</Markdown>
            <h2 className="usa-da-help-content__header">Technical Notes for this Release</h2>
            <Markdown>{props.technical}</Markdown>
            <h2 className="usa-da-help-content-subheading">Getting More Help</h2>
            <p name="membership">
                If you encounter a bug, have a question, or need help,
                please submit an email to the USAspending Service Desk (
                <a href="mailto:usaspending.help@fiscal.treasury.gov">usaspending.help@fiscal.treasury.gov</a>).
                We can better assist you if you provide us as much information as possible,
                including the submission ID, the exact steps we should follow to replicate your issue,
                and the page where you encountered it. The Service Desk Team will email you if more information
                or clarification is needed.
            </p>
        </div>
    );
};

HelpContent.propTypes = propTypes;
export default HelpContent;
